import { ReactNode } from "react"

export type StackedContentsItem = {
  content: ReactNode
  className?: string
  // Added width and height as percentages of the parent container
  width: string
  height: string
}

export interface StackedContentsProps {
  items: StackedContentsItem[]
  className?: string
  angleDegrees?: number
  offsetXPercent?: number
  offsetYPercent?: number
  baseOffsetXPercent?: number
}

const StackedContents = ({
  items,
  className,
  angleDegrees = 0,
  offsetXPercent = 10,
  offsetYPercent = 10,
  baseOffsetXPercent = 0,
}: StackedContentsProps) => {
  return (
    <div className={`relative w-full h-full ${className || ""}`}>
      {items.map((item, index) => {
        // Calculate the offsets based on the index and the number of items
        const xOffset = baseOffsetXPercent + index * offsetXPercent // Offset by x% of the width for each step from the middle
        const yOffset = index * offsetYPercent // Offset by y% of the height for each step from the middle

        // Dynamic rotation and positioning
        const rotationStyle = {
          transform: `translate(${xOffset}%, ${yOffset}%) rotate(${angleDegrees}deg)`,
        }

        return (
          <div
            key={index}
            className={`absolute inset-0 ${item.className || ""}`}
            style={{
              ...rotationStyle,
              width: item.width,
              height: item.height,
            }}
          >
            {item.content}
          </div>
        )
      })}
    </div>
  )
}

export default StackedContents
